import cn from 'classnames';
import type {ReactNode} from 'react';

import {useGetAutoDeliveryDetailsDcx} from '@/api/consumerApi';
import PageSection from '@/components/Layout/PageSection';
import SectionLoader from '@/components/Loader/AppLoader/SectionLoader';

type WidgetContainerProps = {
    id?: string;
    className?: string;
    children?: ReactNode;
};

const AutoDeliveryDcxWidgetContainer = ({id, className, children}: WidgetContainerProps) => {
    const {isFetching} = useGetAutoDeliveryDetailsDcx();

    return (
        <PageSection id={id} className={cn('relative text-start', className)}>
            {children}
            {isFetching && <SectionLoader />}
        </PageSection>
    );
};

const ContentContainer = ({className, children}: WidgetContainerProps) => {
    return <section className={cn('mt-4', className)}>{children}</section>;
};

AutoDeliveryDcxWidgetContainer.ContentContainer = ContentContainer;

export default AutoDeliveryDcxWidgetContainer;
